import { getBundles } from '../../../shared/actions/subscriptionAction';
import { reportError } from '../../../shared/sentry';

// Constants
const MONTHLY_BUNDLE_MONTHS = 1;

/**
 * Create subscription data with monthly bundle
 * @param {Object} promotionData - Optional promotion data
 * @param {Object} purchasePayload - Optional purchase payload
 * @returns {Promise<Object>} Response object with success, data, and error fields
 */
export const getBundlesInfo = async (promotionData, purchasePayload) => {
  try {
    // Get bundles first
    const bundlesResult = await getBundles();

    if (!bundlesResult.success || !bundlesResult.data) {
      return {
        success: false,
        error: 'Failed to get subscription bundles'
      };
    }

    const bundles = Array.isArray(bundlesResult.data) ? bundlesResult.data : [];
    const newArr = [...bundles.slice(1), bundles[0]];
    const monthlyBundle = newArr.find(bundle => bundle.months === MONTHLY_BUNDLE_MONTHS);

    if (!monthlyBundle) {
      return {
        success: false,
        error: 'No monthly subscription plan available'
      };
    }

    // Build subscription data
    const subscriptionData = {
      subscription_bundle: monthlyBundle._id,
      ...(promotionData && promotionData.active && {
        promotionId: promotionData._id
      }),
      ...(purchasePayload && {
        ...purchasePayload
      })
    };

    return {
      success: true,
      data: subscriptionData,
    };
  } catch (error) {
    reportError(error, 'getBundlesInfo subscription');
    return {
      success: false,
      error: error.message || 'Failed to create subscription'
    };
  }
};

